import { UserGroupProps } from '..';
import { USER_GROUP_VALUES } from './constants';
import { UserGroupValues } from './types';

type DefaultValueProps = Pick<UserGroupProps, 'userGroup'>;

export const getDefaultValues = (props: DefaultValueProps) => {
  const { userGroup } = { ...props };
  const {  ...userGroupFields } = {
    ...userGroup,
  };
  let defaultValues: UserGroupValues = USER_GROUP_VALUES;
     defaultValues = { ...userGroupFields };

  return defaultValues;
};
